import { useState } from "react";
import {
  Box,
  Grid,
  Typography,
  TextField,
  IconButton,
  Divider,
  Button,
  Switch,
  FormControlLabel,
  FormControl,
  InputAdornment,
  Tooltip,
} from "@mui/material";

import DeleteIcon from "@mui/icons-material/Delete";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import TextFieldsIcon from "@mui/icons-material/TextFields";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
// import CreatableSearch from "../../../../Base/views/CreatableSearch";
import { CustomButton } from "../../../../Base/views/CustomComponents";
import { generatePrescreenQuestionsHelper } from "../../../../Ancillary/AIConfig/helper/ApiKeyHelper";
// import ClearIcon from "@mui/icons-material/Clear";
import QuizIcon from "@mui/icons-material/Quiz";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const PreScreenQuestionBuilder = ({
  questions,
  setQuestions,
  jobPostData,
  setPostJobData,
  handlepreScreenTemplateLoading,
  prescreenTemplate,
  handleChange,
  errors,
  rolesresponsibilities,
  description,
  prebuilderTitle,
  setPreBuilderTitle,
  handleSaveNewPreScreenTemplate,
}) => {
  /* ---------- helpers ---------- */
  const generateName = (label) => {
    if (!label) return "";
    return label.toLowerCase().replace(/\s+/g, "_").replace(/[^\w]/g, "");
  };

  const updateSequence = (list) =>
    list.map((q, index) => ({
      ...q,
      sequence_no: index,
    }));

  /* ---------- drag ---------- */

  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(questions);
    const [moved] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, moved);

    setQuestions(updateSequence(items));
  };

  /* ---------- add question ---------- */

  const addQuestion = (type) => {
    const newQuestion = {
      name: "",
      type,
      label: "",
      sequence_no: questions.length,
      required: false,
      multiple: false,
      options: type === "radio" ? [{ label: "", value: "" }] : undefined,
      isAI: false
    };

    setQuestions([...questions, newQuestion]);
  };

  /* ---------- update question ---------- */

  const updateQuestion = (index, field, value) => {
    const updated = [...questions];

    updated[index][field] = value;

    if (field === "label") {
      updated[index].name = generateName(value);
    }

    setQuestions(updateSequence(updated));
  };

  /* ---------- delete ---------- */

  const deleteQuestion = (index) => {
    const updated = questions.filter((_, i) => i !== index);
    setQuestions(updateSequence(updated));
  };

  /* ---------- options ---------- */

  const addOption = (index) => {
    const updated = [...questions];

    updated[index].options.push({
      label: "",
      value: "",
    });

    setQuestions(updated);
  };

  const updateOption = (qIndex, oIndex, value) => {
    const updated = [...questions];

    updated[qIndex].options[oIndex] = {
      label: value,
      value: value.toLowerCase().replace(/\s+/g, "_"),
    };

    setQuestions(updated);
  };

  const removeOption = (qIndex, oIndex) => {
    const updated = [...questions];

    updated[qIndex].options.splice(oIndex, 1);

    setQuestions(updated);
  };
  const [loadingAI, setLoadingAI] = useState(false);
  const handleGenerateAI = async () => {
    try {
      setLoadingAI(true);
      
      const job_details = {
        job_title: jobPostData?.title?.job_title,
        industry: jobPostData?.industry_type?.industry_name,
        skills: `${jobPostData?.primary_skill?.map((el) => el?.skill)?.join(", ")},${jobPostData?.secondary_skill?.map((el) => el?.skill)?.join(", ")}`,
        job_description: stripHtml(description),
        roles_responsibilities: stripHtml(rolesresponsibilities)
      };

      const aiResponse = await generatePrescreenQuestionsHelper({
        job_details: job_details
      });

      if (aiResponse && !aiResponse.hasError) {
        const questionsArr = aiResponse.data?.questions;
        if (Array.isArray(questionsArr)) {
          const formatted = questionsArr.map((q, index) => ({
            name: q?.name || q?.label?.toLowerCase().replace(/[^a-z0-9]+/g, "_") || `ai_q_${index}`,
            type: q?.type || "text",
            label: q?.label,
            sequence_no: questions?.length + index,
            required: q?.required ?? false,
            multiple: q?.multiple ?? false,
            options: q?.options || [],
            isAI: true
          }));
          setQuestions((prev) => [...prev, ...formatted]);
        }
      }
    } catch (error) {
      console.error("AI prescreen questions generation error:", error);
    } finally {
      setLoadingAI(false);
    }
  };
  const randomFreq = jobPostData?.prescreen_random_freq?.prequestion_random_freq;
  return (
    <Grid container spacing={2}>
      {/* LEFT PANEL */}

      <Grid item xs={12} md={6}>
        <Box
          border="1px solid #E4E7EC"
          borderRadius={2}
          p={2}
          minHeight="185px"
          maxHeight="calc(100vh - 220px)"
          display="flex"
          flexDirection="column"
        >
          {/* HEADER */}
          <Box mb={1}>
            <Typography fontWeight={600}>Pre-Screen Questions</Typography>
            <Grid container display={"flex"} alignItems={"flex-end"}>
              <Grid item xs={6}>
                <Typography fontSize={12} color="#667085">
                  {questions?.length} Questions
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <FormControl fullWidth>
                  <TextField
                    size="small"
                    value={randomFreq  || ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      if(value === "" || Number(value)) {
                        setPostJobData((prev) => ({
                          ...prev,
                          prescreen_random_freq: {
                            ...prev.prescreen_random_freq,
                            prequestion_random_freq: value,
                          },
                        }));
                      }
                      // const total = questions?.length || 0;
                      // const errorMsg = validateRandomFrequency(value, total);
                      // !errorMsg && setError((prev) => ({
                      //   ...prev,
                      //   prequestion_random_freq: "",
                      // }));
                    }}
                    variant="outlined"
                    fullWidth
                    label="Questions Frequency"
                    name="prequestion_random_freq"
                    // error={!!error?.prequestion_random_freq}
                    // helperText={error?.prequestion_random_freq || ""}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Tooltip
                            title="Number of questions randomly selected from the pre-screen questions during candidate assessment."
                            arrow
                          >
                            <InfoOutlinedIcon
                              sx={{
                                fontSize: 18,
                                color: "#98A2B3",
                                cursor: "pointer",
                              }}
                            />
                          </Tooltip>
                        </InputAdornment>
                      ),
                    }}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </Box>

          <Divider sx={{ mb: 1 }} />

          <Box flex={1} overflow="auto">
            <DragDropContext onDragEnd={handleDragEnd}>
              <Droppable droppableId="questions">
                {(provided) => (
                  <Box ref={provided.innerRef} {...provided.droppableProps}>
                    {!questions || questions?.length === 0 ? (
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        justifyContent="center"
                        color="#98A2B3"
                        mt={"5%"}
                      >
                        <QuizIcon sx={{ fontSize: 40, mb: 1, opacity: 0.6 }} />

                        <Typography fontWeight={600}>
                          No pre-screening questions added
                        </Typography>

                        <Typography fontSize={13}>
                          Add questions manually {jobPostData?.is_ai_job && "or Generate using AI"}
                        </Typography>
                      </Box>
                    ) : (questions || [])?.map((q, index) => (
                      <Draggable
                        key={index}
                        draggableId={String(index)}
                        index={index}
                      >
                        {(provided) => (
                          <Box
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            sx={{
                              border: "1px solid #E4E7EC",
                              borderRadius: 2,
                              px: 2,
                              py: 1,
                              mb: 1,
                              mr: 0.5,
                              bgcolor: "#fff",
                            }}
                          >
                            {/* HEADER */}

                            <Box display="flex" alignItems={"flex-start"}>
                              <Box {...provided.dragHandleProps}>
                                <DragIndicatorIcon
                                  sx={{ ml: -0.5, mr: 1, color: "#999" }}
                                />
                              </Box>
                              <Box
                                  display="flex"
                                  alignItems="center"
                                  gap={1}
                                  bgcolor="#EEF6FF"
                                  px={1}
                                  borderRadius={10}
                                >
                                  <Typography
                                    fontSize={13}
                                    fontWeight={600}
                                    color="#1976d2"
                                  >
                                    Question {index + 1}
                                  </Typography>
                                  {q?.isAI && (
                                    <AutoAwesomeIcon
                                      sx={{ fontSize: 16, color: "#1976d2" }}
                                    />
                                  )}
                                </Box>

                              <IconButton
                                size="small"
                                sx={{ ml: "auto" }}
                                onClick={() => deleteQuestion(index)}
                              >
                                <DeleteIcon color="#637381" />
                              </IconButton>
                            </Box>

                            {/* LABEL */}

                            <TextField
                              fullWidth
                              multiline
                              minRows={2}
                              value={q?.label}
                              placeholder="Enter question"
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  padding: "2px 8px",
                                },
                                "& textarea": {
                                  padding: "2px 0px",
                                },
                              }}
                              onChange={(e) =>
                                updateQuestion(index, "label", e.target.value)
                              }
                            />

                            {/* RADIO OPTIONS */}

                            {q?.type === "radio" && (
                              <Box mt={1}>
                                {q?.options.map((opt, oIndex) => (
                                  <Box
                                    key={oIndex}
                                    display="flex"
                                    gap={1}
                                    mb={1}
                                  >
                                    <TextField
                                      fullWidth
                                      size="small"
                                      value={opt.label}
                                      placeholder="Option"
                                      onChange={(e) =>
                                        updateOption(
                                          index,
                                          oIndex,
                                          e.target.value,
                                        )
                                      }
                                    />

                                    <IconButton
                                      onClick={() =>
                                        removeOption(index, oIndex)
                                      }
                                    >
                                      <DeleteIcon color="#637381" />
                                    </IconButton>
                                  </Box>
                                ))}

                                <Button
                                  size="small"
                                  onClick={() => addOption(index)}
                                >
                                  Add Option
                                </Button>
                              </Box>
                            )}

                            {/* REQUIRED */}

                            <FormControlLabel
                              label="Required"
                              sx={{
                                margin: 0,
                                marginTop: 0.2,
                                gap: "4px",
                                "& .MuiFormControlLabel-label": {
                                  fontSize: "12px",
                                },
                              }}
                              control={
                                <Switch
                                  size="small"
                                  checked={q?.required}
                                  onChange={(e) =>
                                    updateQuestion(
                                      index,
                                      "required",
                                      e.target.checked,
                                    )
                                  }
                                />
                              }
                            />
                          </Box>
                        )}
                      </Draggable>
                    ))}

                    {provided.placeholder}
                  </Box>
                )}
              </Droppable>
            </DragDropContext>
          </Box>
        </Box>
      </Grid>

      {/* RIGHT PANEL */}
      <Grid item xs={12} md={6}>
        <Box
          border="1px solid #E4E7EC"
          borderRadius={2}
          p={2}
          minHeight="185px"
        >
          {/* <Grid item xs={12} mb={1}>
            <FormControl fullWidth>
              {prebuilderTitle ? (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <TextField
                    fullWidth
                    placeholder="Free Text"
                    size="small"
                    label="New Template Title"
                    multiline
                    maxRows={3}
                    value={prebuilderTitle}
                    onChange={(e) => setPreBuilderTitle(e.target.value)}
                    InputProps={{
                      endAdornment: prebuilderTitle && (
                        <InputAdornment position="end">
                          <IconButton
                            size="small"
                            onClick={() => setPreBuilderTitle("")}
                            edge="end"
                          >
                            <ClearIcon fontSize="small" />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <Tooltip
                    title={
                      questions?.length > 0
                        ? "Save as new pre-screening question template"
                        : "Please add question first"
                    }
                  >
                    <span>
                      <Button
                        disabled={questions?.length === 0}
                        variant="outlined"
                        onClick={handleSaveNewPreScreenTemplate}
                      >
                        Save
                      </Button>
                    </span>
                  </Tooltip>
                </Box>
              ) : (
                <CreatableSearch
                  isOptionEqualToValue={(option, value) =>
                    +option.prescreen_template_id ===
                    +value.prescreen_template_id
                  }
                  customBackground
                  label="Pre Screen Questions Template"
                  name="prescreen_template_id"
                  value={jobPostData?.prescreen_template_id}
                  loading={() => handlepreScreenTemplateLoading()}
                  fieldLabel="prescreen_template_name"
                  variant={"contained"}
                  size="small"
                  data={prescreenTemplate}
                  onChangeEvent={handleChange}
                  {...(errors.prescreen_template_id && {
                    error: true,
                    helperText: errors.prescreen_template_id,
                  })}
                />
              )}
            </FormControl>
          </Grid> */}
          <Typography fontWeight={600}>Add Your Question</Typography>
          <Grid container spacing={2}>
            <Grid item>
              <Button
                fullWidth
                startIcon={<TextFieldsIcon />}
                onClick={() => addQuestion("text")}
              >
                Text Question
              </Button>
            </Grid>
            <Grid item>
              <Button
                fullWidth
                startIcon={<RadioButtonCheckedIcon />}
                onClick={() => addQuestion("radio")}
              >
                Choice Question
              </Button>
            </Grid>
            <Grid item>
              <Button
                fullWidth
                startIcon={<CloudUploadIcon />}
                onClick={() => addQuestion("file")}
              >
                File Upload
              </Button>
            </Grid>
          </Grid>
          <Box mt={3} display={"flex"} justifyContent={"end"}>
            {jobPostData?.is_ai_job && <CustomButton
              variant="contained"
              onClick={handleGenerateAI}
              startIcon={<AutoAwesomeIcon />}
              className="ai-mpl-btn"
              sx={{ width: "200px" }}
              loading={loadingAI}
            >
              {loadingAI ? "Generating...." : "Generate Question"}
            </CustomButton>}
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};
const stripHtml = (html) => {
  if (!html) return "";
  return html
    .replace(/<[^>]*>/g, "")
    .replace(/\s+/g, " ")
    .trim();
};
export default PreScreenQuestionBuilder;
